import { render } from "./QuotationListPage.vue?vue&type=template&id=de8da112&scoped=true&ts=true"
import script from "./QuotationListPage.vue?vue&type=script&lang=ts"
export * from "./QuotationListPage.vue?vue&type=script&lang=ts"

import "./QuotationListPage.vue?vue&type=style&index=0&id=de8da112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8da112"]])

export default __exports__